<template><div><h1>VUX V2.5.7 released</h1>
<h2><a href="/en/components/checklist.html">Checklist</a></h2>
<ul><li>[feature] Support `label` param for on-change event #1783</li>
</ul>
<h2><a href="/en/components/confirm.html">Confirm</a></h2>
<ul><li>[feature] Support prop:input-attrs #1799</li>
</ul>
<h2><a href="/en/components/loading.html">Loading</a></h2>
<ul><li>[fix] fix vue@2.4 no setter warning, use :show instead of v-model #1798</li>
</ul>
<h2><a href="/en/components/panel.html">Panel</a></h2>
<ul><li>[feature] use v-html binding #1784</li>
</ul>
<h2><a href="/en/components/popup-picker.html">PopupPicker</a></h2>
<ul><li>[fix] Fix render issue after changing value #1793</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.5.7 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.5.7-120.vue?0c675599